module.exports = __webpack_public_path__ + "img/53.ba9d40d2.jpg";